import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback } from 'react';
import { useFireAdControlAnalyticsEvents, useFireCrossFlowAnalyticsEvents } from '@atlassian/surface-analytics';
import { createSurfaceLoader, createSurfaceRenderer, createSurfaceSdk } from '@atlassian/surface-sdk';
import { ExperienceSuccess, useUFOComponentExperience } from '@atlassian/ufo';
import { useAnalyticsSideEffect } from './controllers/analytics-side-effects';
import { createContextMiddleware } from './controllers/context-middlewares';
import { observabilitySideEffects } from './controllers/observability-side-effects';
import { AppRecommendations } from './ui/app-recommendations';
import { AppRecommendationsSectionHeader } from './ui/app-recommendations/app-recommendation-section-header';
import { AppRecommendationsList } from './ui/app-recommendations/app-recommendations-list';
import { AppRecommendationsWithTitle } from './ui/app-recommendations/app-recommendations-with-title';
import { showRecommendations } from './utils/ufo';
var gqlEndpoint = '/gateway/api/graphql';
var SurfaceRenderer = createSurfaceRenderer({
  AppRecommendationsSectionHeader: AppRecommendationsSectionHeader,
  AppRecommendationsList: AppRecommendationsList,
  AppRecommendations: AppRecommendations,
  AppRecommendationsWithTitle: AppRecommendationsWithTitle
});
var surfaces = {
  appSwitcher: {
    surfaceType: 'DiscoverySection',
    surfaceKey: 'app-recommendations-surface',
    contextDependencies: ['tenantId', 'subproduct', 'sessionId', 'locale', 'isSiteAdmin', 'workspaceId', 'orgId', {
      field: 'product',
      required: true
    }, {
      field: 'switcherMenuHasBeenOpened',
      required: true
    }],
    fallback: null
  }
};
var disabledSdk = {
  DiscoverySurface: function DiscoverySurface() {
    return null;
  },
  setContext: function setContext(c) {
    return c;
  },
  useDiscoverySdk: function useDiscoverySdk() {
    return {
      setContext: function setContext(c) {
        return c;
      }
    };
  }
};
export var createDiscoverySdk = function createDiscoverySdk(config) {
  var _config$surfaceLoader, _config$graphqlEndpoi, _config$sideEffects;
  if ((config === null || config === void 0 ? void 0 : config.enable) === false) {
    return disabledSdk;
  }
  var surfaceLoader = (_config$surfaceLoader = config === null || config === void 0 ? void 0 : config.surfaceLoader) !== null && _config$surfaceLoader !== void 0 ? _config$surfaceLoader : createSurfaceLoader({
    gqlEndpoint: (_config$graphqlEndpoi = config === null || config === void 0 ? void 0 : config.graphqlEndpoint) !== null && _config$graphqlEndpoi !== void 0 ? _config$graphqlEndpoi : gqlEndpoint
  });
  var _createSurfaceSdk = createSurfaceSdk({
      surfaces: surfaces,
      surfaceLoader: surfaceLoader,
      context: _objectSpread({}, config === null || config === void 0 ? void 0 : config.context),
      sideEffects: [observabilitySideEffects].concat(_toConsumableArray((_config$sideEffects = config === null || config === void 0 ? void 0 : config.sideEffects) !== null && _config$sideEffects !== void 0 ? _config$sideEffects : [])),
      contextMiddleware: createContextMiddleware()
    }),
    useSurface = _createSurfaceSdk.useSurface,
    updateContext = _createSurfaceSdk.updateContext;
  return {
    DiscoverySurface: function DiscoverySurface(_ref) {
      var surface = _ref.surface,
        fallback = _ref.fallback,
        baseHeadingLevel = _ref.baseHeadingLevel,
        errorFallback = _ref.errorFallback;
      var analyticsSideEffect = useAnalyticsSideEffect(useFireAdControlAnalyticsEvents(), useFireCrossFlowAnalyticsEvents());
      var surfaceProps = useSurface(surface, analyticsSideEffect);
      useUFOComponentExperience(showRecommendations);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SurfaceRenderer, _extends({}, surfaceProps, {
        fallback: fallback !== null && fallback !== void 0 ? fallback : surfaceProps.fallback,
        errorFallback: errorFallback,
        baseHeadingLevel: baseHeadingLevel
      })), /*#__PURE__*/React.createElement(ExperienceSuccess, {
        experience: showRecommendations
      }));
    },
    setContext: updateContext,
    useDiscoverySdk: function useDiscoverySdk() {
      var setContextCallback = useCallback(updateContext, []);
      return {
        setContext: setContextCallback
      };
    }
  };
};